import { StoryblokImage } from '@cinch-nx/data-storyblok'
import { StoryBlokCarReviewSection } from '../types/car-review-page'

export const getGalleryImages = (
  gallery:
    | {
        image: StoryblokImage
      }[]
    | undefined,
) => (gallery ? gallery.map((image) => image.image) : [])

// add a placeholder image if there are no images in the gallery
export const getFormattedGalleryImages = (
  galleryImages: StoryblokImage[],
  placeholderImage: StoryblokImage,
) => (galleryImages.length === 0 ? [placeholderImage] : galleryImages)

// get the default image for the section (ie. if no image is provided, use the placeholder image)
export const getDefaultSectionImage = (
  section: StoryBlokCarReviewSection[],
  placeholderImage: StoryblokImage,
) => (section[0].image?.filename ? section[0].image : placeholderImage)
